import * as React from 'react';
import styled from 'styled-components';
import { SurveyTopic } from '../../../amorg-common';
import { colors } from '../../../designSystem/colors/color';
import { AnswerRatioBarGraph } from '../../../features/surveys/report/AnswerRatioBarGraph';
import { Card } from '../../../designSystem/Card';
import { Flex, FlexItem } from '../../../designSystem/compositeComponents/FlexHelpers';
import { RadialPctChart } from '../../../designSystem/graphs/RadialPctChart';

type SurveyTopicInfoPanelProps = {
    surveyTopic: SurveyTopic
}
export function SurveyTopicInfoPanel(props:SurveyTopicInfoPanelProps):JSX.Element
{
    const topicTitle = props.surveyTopic.data.title;
    let answerCount = props.surveyTopic?.data.selections.totalSelections || 0;
    const average = props.surveyTopic.data.selections.selectionAverage?.toFixed(2) || 0;
    const agreeOrBetterPct = (props.surveyTopic.data.selections.data.value4Count + props.surveyTopic.data.selections.data.value5Count)
        / props.surveyTopic.data.selections.totalSelections * 100;

    if(answerCount > 0){
        if(props.surveyTopic.linkType === 'theme'){
            const questionsInTheme = props.surveyTopic.questionsInTheme
            answerCount = answerCount / questionsInTheme;
        }
        else if(props.surveyTopic.linkType === 'indicator'){
            const questionsWithIndicator = props.surveyTopic.questionsWithIndicator;
            answerCount = answerCount / questionsWithIndicator;
        }
        else if(props.surveyTopic.linkType === 'question'){
            // answerCount = answerCount;
        }
            
    }

    let topicText = <></>;

    if(props.surveyTopic.linkType === 'theme')
        topicText = 
            <span>
                Emnet vedrører <HighlightedText>temaet {topicTitle}</HighlightedText> fra spørgeskemaet. Temaet indeholder <HighlightedText>{props.surveyTopic.questionsInTheme} spørgsmål</HighlightedText>, og er blevet besvaret af <HighlightedText>{answerCount==1 ? '1 besvarelse' : `${answerCount}`} deltagere.</HighlightedText> Ud af disse er <HighlightedText>{agreeOrBetterPct.toFixed()}%</HighlightedText> besvaret med <HighlightedText>Enig</HighlightedText> eller <HighlightedText>Meget enig</HighlightedText>.<br />
            </span>;

    else if(props.surveyTopic.linkType === 'indicator')
        topicText = 
            <span>Emnet vedrører <HighlightedText>indikatoren {topicTitle}</HighlightedText> fra spørgeskemaet. Indikatoren er tilknyttet <HighlightedText>{props.surveyTopic.questionsWithIndicator} spørgsmål
            </HighlightedText>, og da handleplanen omfatter <HighlightedText>{answerCount==1 ? '1 besvarelse' : `${answerCount} besvarelser`}</HighlightedText> er gennemsnittet udregnet på basis af <HighlightedText>{props.surveyTopic.data.selections.totalSelections} valg
            </HighlightedText> og er på <HighlightedText>på {average} ud af maksimalt 5</HighlightedText>.
            </span>;

    else if(props.surveyTopic.linkType === 'question')
        topicText = 
            <span>Emnet vedrører <HighlightedText>spørgsmålet {topicTitle}</HighlightedText> fra spørgeskemaet. 
            Handleplanen omfatter <HighlightedText>{answerCount==1 ? '1 besvarelse' : `${answerCount} besvarelser`}</HighlightedText> med et <HighlightedText>gennemsnit på {average}</HighlightedText>.
            </span>;

    return (
        <>
            {props.surveyTopic &&
                <Flex flexDirection="row">
                    <FlexItem>
                        <RadialPctChart dim='100px' pct={agreeOrBetterPct} />
                    </FlexItem>
                    <Flex flexDirection="column" gap={8}>
                        <Card variant="outlined">
                             <small>
                                 {topicText}
                             </small>
                         </Card>
                         <AnswerRatioBarGraph heightPx={10} legend={'classic'} data ={props.surveyTopic.data.selections.data} />

                    </Flex>
                </Flex>
            }
        </>
    );
}

const HighlightedText = styled.span`
    font-weight: 800;
    color:${colors.text.highlighted};
`;